import { ApplicationConfig } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { enIN } from 'date-fns/locale';

import { routes } from './app.routes';
import { provideSeoService } from '@geekeno/ngx-website/services';

const DATE_FORMATS = {
  parse: {
    dateInput: 'P',
  },
  display: {
    dateInput: 'dd-LLL-uuuu',
    monthYearLabel: 'LLL uuuu',
    dateA11yLabel: 'PP',
    monthYearA11yLabel: 'LLLL uuuu',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(),
    { provide: MAT_DATE_LOCALE, useValue: enIN },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    provideSeoService({
      baseURL: 'https://theshoreagonda.com',
      defaultSiteImage: '/assets/logo.svg',
      locale: 'en-IN',
      autoUpdateCanonicalURL: true,
      warnIfMissingOnRoute: true,
    }),
  ],
};
